import React, { useCallback } from "react";
import styled from "styled-components";
import { useUploadOperations } from "../hooks/useUploadOperations";
import TopNavBar from "../components/navigation/TopNavBar";
import FileUpload from "../components/FileUpload";
import UploadResultBanner from "../components/ui/UploadResultBanner";

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 24px 32px;
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 24px;
  letter-spacing: -0.5px;
`;

// =============================================
// Admin-only page for uploading Excel operation
// files to Supabase.
//
// This page is only reachable via AdminOnlyRoute
// so non-admin users will never see it.
// The upload pipeline is managed by the
// useUploadOperations hook.
// =============================================
const UploadPage: React.FC = () => {
  const {
    uploadResult,
    isUploading,
    uploadError,
    uploadFile,
    clearUploadResult,
  } = useUploadOperations();

  const handleFileUpload = useCallback(
    async (file: File): Promise<void> => {
      clearUploadResult();
      await uploadFile(file);
    },
    [uploadFile, clearUploadResult]
  );

  return (
    <>
      <TopNavBar />
      <PageContainer>
        <PageTitle>Upload Operations File</PageTitle>

        <FileUpload
          onFileUpload={handleFileUpload}
          isUploading={isUploading}
        />

        <UploadResultBanner
          result={uploadResult}
          errorMessage={uploadError}
          onDismiss={clearUploadResult}
        />
      </PageContainer>
    </>
  );
};

export default UploadPage;
